import { createContext, type PropsWithChildren, type ReactElement } from 'react';
import useCorporateBondScreenerSidebarFilter from './useCorporateBondScreenerSidebarFilter';
import type { TFilterPayload } from './useCorporateBondScreenerSidebarFilter';
import type { IFilterBoundaryRegion } from '@/creditflowresearch/domain/vo/Bondscreener';
import type { IApplyOptions } from '@/creditflowresearch/application/BondScreener/Sidebar/createUseBondScreenerSidebarFilter';

export type CorporateBondScreenerSidebarFilterContextType = ReturnType<typeof useCorporateBondScreenerSidebarFilter>;

export const CorporateBondScreenerSidebarFilterContext =
  createContext<CorporateBondScreenerSidebarFilterContextType | null>(null);

interface IProviderProps extends PropsWithChildren {
  isOpen: boolean,
  payload: TFilterPayload,
  onApply: (filters: TFilterPayload, boundaryRegions: IFilterBoundaryRegion[], options?: IApplyOptions) => void,
}

export const CorporateBondScreenerSidebarFilterProvider = ({
  children,
  isOpen,
  payload,
  onApply,
}: IProviderProps): ReactElement => (
  <CorporateBondScreenerSidebarFilterContext.Provider
    value={ useCorporateBondScreenerSidebarFilter({ isOpen, payload, onApply }) }
  >
    { children }
  </CorporateBondScreenerSidebarFilterContext.Provider>
);
